import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { Divider, Grid } from '@material-ui/core';
import { OutletIcon } from 'assets';
import Phone from 'assets/icons/phone.svg';
import BigNumber from 'bignumber.js';
import { BillFooterReceipt } from 'components/Footer/BillFooterReceipt';
import { CreditCardType, PaymentClass } from 'generated/graphql';
import { convertDate24Hrs } from 'helpers/formatDate';
import React from 'react';
import '../billSettlement.scss';
import * as bxlCommon from '../BixolonJS/bxlcommon';
import * as bxlPOS from '../BixolonJS/bxlpos';

const formatMoney = (currencyCode: string, value: number) =>
	`${currencyCode || ''}${Number(value || 0).toLocaleString('en-MY', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`;

export const billReceiptDisplay = (
	outlet,
	outletID,
	getBill,
	orderItems,
	footerToken,
	negOrderItem,
	hidden?: Boolean,
	mode?: string,
	hotelGuest?: any,
	hotelDebtor?: any,
	officer?: any,
	staff?: any,
	latestPayment?: any,
	currencyCode?: string,
) => {
	const currency = currencyCode || outlet?.currencyCode || '';

	const creditClass = creditClass => {
		let credClass;

		if (creditClass === CreditCardType.AmericanExpressCard) {
			credClass = 'American Express Card';
		} else if (creditClass === CreditCardType.DinersCard) {
			credClass = 'Diners Card';
		} else if (creditClass === CreditCardType.JcbCard) {
			credClass = 'JCB Card';
		} else if (creditClass === CreditCardType.Mastercard) {
			credClass = 'Master Card';
		} else if (creditClass === CreditCardType.UnionpayCard) {
			credClass = 'UNION PAY';
		} else if (creditClass === CreditCardType.VisaCard) {
			credClass = 'Visa Card';
		} else if (creditClass === CreditCardType.DebitCard) {
			credClass = 'Debit Card';
		}
		return credClass;
	};

	const chargeToInfo = paymentClass => {
		let info1, info2;
		if (paymentClass === PaymentClass.Credit) {
			info1 = creditClass(latestPayment?.creditCardType);
			info2 = latestPayment?.cardNo
				? `****${String(latestPayment?.cardNo).slice(-4)}`
				: null;
		} else if (paymentClass === PaymentClass.Room) {
			info1 = hotelGuest?.RoomNo ? hotelGuest?.RoomNo : null;
			info2 = hotelGuest?.GuestName;
		} else if (paymentClass === PaymentClass.Debtor) {
			info1 = hotelDebtor?.GuestType;
			info2 = hotelDebtor?.GuestName;
		} else if (paymentClass === PaymentClass.Staff) {
			info1 = staff?.designation;
			info2 = staff?.name;
		} else if (paymentClass === PaymentClass.Officer) {
			info1 = officer?.designation;
			info2 = officer?.name;
		}
		if (info1 || info2) {
			return (
				<div className="session">
					<div className="flex session">
						<div className="mdDesc flex-space">
							<span>{`Charged to `}</span>
							{info1 && <span>{`${info1} | `}</span>}
							<span className="highlight-text" style={{ color: '#ff9800' }}>
								{`${info2}`}
							</span>
						</div>
					</div>
				</div>
			);
		}
	};

	const bill = getBill?.[0];
	const order = bill?.order;
	const table = order?.table;
	const patronClass = order?.patron?.patronClass;
	const patronName = order?.patronName;
	const companyAddress = outlet?.company?.address;
	const addressLine =
		(companyAddress?.address ?? outlet?.address?.address ?? '') +
		', ' +
		(companyAddress?.postCode ?? outlet?.address?.postCode ?? '') +
		', ' +
		(companyAddress?.city ?? outlet?.address?.city ?? '') +
		', ' +
		(companyAddress?.state ?? outlet?.address?.state ?? '') +
		'.';

	const tableLabel = table
		? `${table?.prefix ?? ''}${table?.tableNumber ?? ''}`
		: 'Takeaway';

	return (
		<div
			style={
				hidden
					? {
							zIndex: -40,
							top: 0,
							left: 0,
							position: 'fixed',
							width: '350px',
							fontFamily: ['Poppins', 'sans-serif'].join(',') + ' !important',
					  }
					: {
							marginTop: '0px',
							zIndex: 40,
							position: 'relative',
					  }
			}
			id={hidden ? 'share-receipt' : null}
		>
			<CardContents>
				<Grid container>
					<Grid item xs={12} style={{ textAlign: 'center' }}>
						{outlet?.logo?.fileURL ? (
							<img
								className="icon-svg"
								style={{
									width: '100px',
									marginBottom: '10px',
									height: '100px',
								}}
								src={outlet?.logo?.fileURL}
							/>
						) : (
							<img
								className="icon-svg"
								style={{
									height: '90px',
									width: '150px',
									marginBottom: '5px',
								}}
								src={OutletIcon}
							/>
						)}
					</Grid>
				</Grid>

				<div
					className="content-wrap full"
					style={{
						textAlign: 'center',
						marginBottom: '1px',
						fontSize: '14px',
						color: '#212121',
						fontWeight: 500,
					}}
				>
					<div>{outlet?.company?.name}</div>
				</div>
				<div
					className="content-wrap full"
					style={{
						textAlign: 'center',
						marginBottom: '1px',
						marginTop: '-3px',
						fontSize: '14px',
						color: '#212121',
						fontWeight: 500,
					}}
				>
					<div>{`(Company Reg No: ${outlet?.company?.companyRegNo ??
						'NA'})`}</div>
				</div>
				<div
					className="content-wrap full"
					style={{
						textAlign: 'center',
						marginBottom: '1px',
						marginTop: '-3px',
						fontSize: '14px',
						color: '#212121',
						fontWeight: 500,
					}}
				>
					<div>{`(Company Tin No: ${outlet?.company?.tin ?? 'NA'})`}</div>
				</div>
				<div
					className="content-wrap full"
					style={{
						textAlign: 'center',
						marginBottom: '1px',
						marginTop: '-3px',
						fontSize: '14px',
						color: '#212121',
						fontWeight: 500,
					}}
				>
					<div>{`(SST Reg No: ${outlet?.company?.sstNo ??
						outlet?.taxRegistrationNo ??
						'NA'})`}</div>
				</div>
				<div
					className="content-wrap full"
					style={{
						textAlign: 'center',
						marginBottom: '-5px',
						marginTop: '-5px',
						fontSize: '14px',
						fontWeight: 500,
					}}
				>
					<div style={{ color: '#212121' }}>{addressLine}</div>
				</div>

				<div
					className="xsTitle content-wrap full"
					style={{
						textAlign: 'center',
						fontSize: '14px',
						marginBottom: '0px',
						marginTop: '5px',
					}}
				>
					<img
						src={Phone}
						style={{
							width: '10px',
							height: '10px',
							paddingRight: '3px',
						}}
					/>
					<span>{outlet?.contactNo}</span>
				</div>

				<div
					className="xsTitle content-wrap full"
					style={{
						textAlign: 'center',
						fontSize: '16px',
						marginBottom: '5px',
						marginTop: '5px',
						paddingBottom: '5px',
					}}
				>
					<span>{outlet?.name}</span>
				</div>

				{mode == 'void-bill' ? (
					<div className="session">
						<div className="flex session">
							<div className="xsTitle flex-space desc color-red">Voided Bill</div>
						</div>
					</div>
				) : (
					<>
						<div
							className="content-wrap full"
							style={{ marginTop: '5px', marginBottom: '3px' }}
						>
							<div className={'xsTitle'} style={{ fontSize: '16px' }}>
								{`Bill No`}{' '}
								<span style={{ verticalAlign: 'middle', paddingLeft: '1px' }}>
									:
								</span>{' '}
								&nbsp;
								{bill?.billNo}
								<span
									className="mdDesc right-info"
									style={{ fontSize: '16px' }}
								>
									{`${convertDate24Hrs(bill?.createdTs)}`}
								</span>
							</div>
						</div>

						<div className="content-wrap full" style={{ marginBottom: '3px' }}>
							<div className={'mdDesc'} style={{ fontSize: '16px' }}>
								{patronClass}
								{patronClass !== 'Member' ? (
									<span style={{ verticalAlign: 'right', paddingLeft: '47px' }}>
										:
									</span>
								) : null}{' '}
								&nbsp;
								{patronClass !== 'Member'
									? patronName
										? `${patronName}`
										: `-`
									: null}
							</div>
						</div>

						{!outlet?.isRetail && (
							<div
								className="content-wrap full"
								style={{ marginBottom: '3px' }}
							>
								<div className="mdDesc" style={{ fontSize: '16px' }}>
									{`Table`}{' '}
									<span
										style={{ verticalAlign: 'right', paddingLeft: '48px' }}
									>
										:
									</span>{' '}
									&nbsp;
									{tableLabel}
								</div>
							</div>
						)}

						{order?.serviceMode === 'DINE_IN' && (
							<div
								className="content-wrap full"
								style={{ marginBottom: '3px' }}
							>
								<div className={'mdDesc'} style={{ fontSize: '16px' }}>
									{`Cover`}{' '}
									<span
										style={{
											verticalAlign: 'middle',
											paddingLeft: '45px',
										}}
									>
										:
									</span>{' '}
									&nbsp;
									{order?.pax ?? '-'}
								</div>
							</div>
						)}

						<div className="content-wrap full" style={{ marginBottom: '3px' }}>
							<div className={'mdDesc'} style={{ fontSize: '16px' }}>
								{`Cashier`}{' '}
								<span
									style={{
										verticalAlign: 'middle',
										paddingLeft: '31px',
									}}
								>
									:
								</span>{' '}
								&nbsp;-
							</div>
						</div>
					</>
				)}

				<Divider style={{ display: 'flex', width: '100%', color: 'black' }} />

				{orderItems?.map((v, index) => {
					const remainingQty = v?.quantity - (negOrderItem[v?.ID] ?? 0);
					const qtyRatio =
						v?.quantity > 0 ? remainingQty / v?.quantity : 0;
					const lineAmount = new BigNumber(v?.amount || 0)
						.plus(v?.taxAmount || 0)
						.plus(v?.serviceCharge || 0)
						.times(qtyRatio)
						.toNumber();

					return (
						<div className="dialog-dynamic-content" key={v?.ID || index}>
							<div className="session">
								<div className="flex session">
									<div
										className="xsTitle flex-space desc text-noflow"
										style={{
											alignSelf: 'center',
											fontSize: '16px',
											paddingBlockEnd: '4px',
											color: '#212121',
										}}
									>
										{`${v?.openItemName ?? v?.menuItem?.name} x${remainingQty}`}
									</div>
									<div
										className="xsTitle rightText"
										style={{
											fontSize: '16px',
											paddingBlockEnd: '4px',
											color: '#212121',
										}}
									>
										{formatMoney(currency, lineAmount)}
									</div>
								</div>
								{v?.orderItemOption?.length
									? v?.orderItemOption?.map(x => (
											<>
												{x?.orderItemOptionItem?.map(opt => (
													<div className="flex session" key={opt?.ID}>
														<div
															className="xsTitle flex-space"
															style={{
																color: '#757575',
																fontWeight: 500,
																alignSelf: 'center',
																fontSize: '16px',
															}}
														>
															{opt?.optionItem?.name}
														</div>
														<div
															className="xsTitle rightText"
															style={{
																color: '#757575',
																fontWeight: 500,
																fontSize: '16px',
															}}
														>
															{formatMoney(
																currency,
																Math.abs((opt?.price ?? opt?.unitPrice ?? 0) * qtyRatio),
															)}
														</div>
													</div>
												))}
											</>
									  ))
									: v?.orderItemSetMenuOption?.map(x => (
											<>
												{x?.orderItemSetMenuOptionItem?.map((e, i) => (
													<div
														className="xsTitle"
														key={i}
														style={{
															color: '#757575',
															fontWeight: 500,
															paddingBottom: '2px',
															fontSize: '16px',
														}}
													>
														{e?.setMenuOptionItem?.menuItem?.name}
													</div>
												))}
											</>
									  ))}
							</div>
						</div>
					);
				})}

				<Divider style={{ display: 'flex', width: '100%', color: 'black' }} />

				<BillFooterReceipt
					discount={footerToken?.discount}
					subtotal={footerToken?.subtotal}
					serviceCharge={footerToken?.serviceCharge}
					tax={footerToken?.tax}
					total={footerToken?.total}
					mode={mode}
					query={getBill}
					latestPayment={latestPayment}
					currencyCode={currency}
					outletID={outletID}
					orderID={order?.ID}
					order={order}
					taxSchemeInfo={order?.taxSchemeInfo}
					taxSchemeFooterInfo={order?.taxSchemeFooterInfo}
				/>

				{mode !== 'void-bill' && (
					<div
						className="dialog-dynamic-content"
						style={{ paddingTop: '6px', paddingBottom: '18px' }}
					>
						{chargeToInfo(
							Array.isArray(latestPayment)
								? latestPayment?.[0]?.paymentClass
								: latestPayment?.paymentClass,
						)}
					</div>
				)}

				{bill?.signature !== undefined &&
					bill?.signature !== null &&
					Object.keys(bill?.signature).length > 0 && (
						<img
							className="icon-svg"
							style={{
								height: '120px',
								width: '120px',
								margin: '0px 10px 10px',
							}}
							src={bill?.signature?.fileURL}
						/>
					)}
			</CardContents>
		</div>
	);
};

export const printReceipt = async (fileURL, printerName) => {
	let nonWhiteSpace = printerName.replace(/ /g, '');

	let posID = 1;

	const viewResult = x => {
		console.log(
			'%cPrinter Results',
			'color: #12850b;',
			JSON.stringify(
				{ posID: posID, printerName: nonWhiteSpace, result: x },
				null,
				'\t',
			),
		);
	};

	const printImage = async () => {
		await bxlPOS.setPosId(posID);
		await bxlPOS.printBitmap(fileURL, 469, 1, false);
		await bxlPOS.cutPaper(1);
		let posData = bxlPOS.getPosData();
		await bxlCommon.requestPrint(nonWhiteSpace, posData, viewResult);
		posID++;
	};

	bxlPOS.checkPrinterStatus();
	return await printImage();
};
